const REDIRECT_KEY = 'postLoginRedirect'
const REDIRECT_MAX_AGE_MS = 60 * 60 * 1000

export const savePostLoginRedirect = (path: string) => {
  try {
    localStorage.setItem(REDIRECT_KEY, JSON.stringify({ path, savedAt: Date.now() }))
  } catch (e) {}
}

export const clearPostLoginRedirect = () => {
  try {
    localStorage.removeItem(REDIRECT_KEY)
  } catch (e) {}
}

export const getPostLoginRedirect = (eventcode: string) => {
  const fallback = '/' + eventcode + '/welcome/'
  let saved: string | null = null
  try {
    const parsed = JSON.parse(localStorage.getItem(REDIRECT_KEY) || 'null')
    if (parsed && typeof parsed.path === 'string' && Date.now() - parsed.savedAt < REDIRECT_MAX_AGE_MS) {
      saved = parsed.path
    }
  } catch (e) {}
  clearPostLoginRedirect()

  if (saved && eventcode && saved.toLowerCase().startsWith('/' + eventcode.toLowerCase() + '/')) {
    return saved
  }
  return fallback
}
